import {createAsyncThunk} from '@reduxjs/toolkit'

import {FLEA_MARKET} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/** 플리마켓 홈으로 이동 */
const navigateToFleaMarketHome = createAsyncThunk<NavigationResult, NavigationTypeSelectableParam | void, ThunkApi>(
    'navigateTo/shoppingHome',
    async (args) => {
        const {forceLocationChange = false} = args ?? {}

        if (forceLocationChange) {
            changeBrowserLocation({
                // 반응형으로 구현되어 PC/MO 분리 없음
                url: FLEA_MARKET,
                type: 'PUSH',
            })
            // page 이동은 그 자체로 추가동작 없이 resolve 된다
            return Promise.resolve()
        }

        openNewTab({url: FLEA_MARKET})
    },
)

export default navigateToFleaMarketHome
